import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import store from '@/store'
import { ReportAgendPeriodicitiesServices } from '../../services/modules/report-agend-periodicity.service'

@Module
export default class ReportAgendPeriodicitiesStore extends VuexModule {
    reportAgendPeriodicities: object[] = []

    @Mutation
    updateAgendPeriodicities (newPeriodicities: object[]) {
        this.reportAgendPeriodicities = newPeriodicities
    }

    @Action
    getReportAgendPeriodicities () {
        return new Promise((resolve) => {
            ReportAgendPeriodicitiesServices.getAgendPeriodicities()
                .then(resp => {
                    store.commit('updateAgendPeriodicities', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
